<template>
  <section>
    <div class="hero min-h-screen bg-base-100 p-4">
      <div class="hero-content flex-col lg:flex-row-reverse mt-12 md:mt-0">
        <CardNotContent/>
        <!-- <div class="text-center lg:text-left">
          <h1 class="text-3xl md:text-5xl font-bold">Ponerse en contacto</h1>
          <p class="py-2 md:py-6 text-sm md:text-xl">
            Estoy disponible para trabajar en sus proyectos y hacer realidad sus
            ideas. Estoy a un clic de distancia.
          </p>
        </div> -->
        <!-- <div class="card flex-shrink-0 w-full sm:w-2/5 shadow-2xl bg-base-100">
          <div class="card-body grid grid-cols-4">
            <div class="form-control col-span-4">
              <input
                type="text"
                placeholder="Nombre completo"
                class="input input-bordered focus:input-primary"
              />
            </div>
            <div class="form-control col-span-4 md:col-span-2">
              <input
                type="text"
                placeholder="Email"
                class="input input-bordered focus:input-primary" 
              />
            </div>
            <div class="form-control col-span-4 md:col-span-2">
              <input
                type="number"
                min="0"
                placeholder="Número de teléfono"
                class="input input-bordered focus:input-primary"
              />
            </div>
            <div class="form-control col-span-4">
              <textarea
                class="textarea textarea-bordered focus:textarea-primary c-text-area"
                rows="5"
                placeholder="Escribe tu mensaje"
              ></textarea>
            </div>
            <div class="form-control mt-6 col-span-4">
              <button class="btn btn-primary">Enviar</button>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </section>
</template>

<script>

import CardNotContent from "@/components/CardNotContent.vue"

export default {
  name: "ContactView",
  components:{
    CardNotContent
  }
};
</script>

<style scoped>
.c-text-area {
  resize: none;
}
</style>